/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsPackedCheckResVo } from './GoodsPackedCheckResVo';
import {
    GoodsPackedCheckResVoFromJSON,
    GoodsPackedCheckResVoFromJSONTyped,
    GoodsPackedCheckResVoToJSON,
    GoodsPackedCheckResVoToJSONTyped,
} from './GoodsPackedCheckResVo';

/**
 * 
 * @export
 * @interface ResponseGoodsPackedCheckResVo
 */
export interface ResponseGoodsPackedCheckResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseGoodsPackedCheckResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseGoodsPackedCheckResVo
     */
    message?: string;
    /**
     * 
     * @type {GoodsPackedCheckResVo}
     * @memberof ResponseGoodsPackedCheckResVo
     */
    data?: GoodsPackedCheckResVo;
}

/**
 * Check if a given object implements the ResponseGoodsPackedCheckResVo interface.
 */
export function instanceOfResponseGoodsPackedCheckResVo(value: object): value is ResponseGoodsPackedCheckResVo {
    return true;
}

export function ResponseGoodsPackedCheckResVoFromJSON(json: any): ResponseGoodsPackedCheckResVo {
    return ResponseGoodsPackedCheckResVoFromJSONTyped(json, false);
}

export function ResponseGoodsPackedCheckResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGoodsPackedCheckResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : GoodsPackedCheckResVoFromJSON(json['data']),
    };
}

export function ResponseGoodsPackedCheckResVoToJSON(json: any): ResponseGoodsPackedCheckResVo {
    return ResponseGoodsPackedCheckResVoToJSONTyped(json, false);
}

export function ResponseGoodsPackedCheckResVoToJSONTyped(value?: ResponseGoodsPackedCheckResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': GoodsPackedCheckResVoToJSON(value['data']),
    };
}

